export default __webpack_public_path__ + "static/media/checkMarkYes.fe7b2fb9.svg";